import { type SignedUrlInput } from '../../providers';

export function mapStorageObjectToFormFileInput(
  storageObject: {
    name: string;
    type: string;
    size: number;
    value: {
      url: string;
      name: string;
    };
  }[],
): SignedUrlInput[] {
  return storageObject.map((file) => ({
    url: file.value.url,
    name: file.name,
    key: file.value.name,
    type: file.type,
    size: file.size,
  }));
}
